<template>
  <div class="row">
    <input type="hidden" :name="name" :value="completeValue" />
    <div v-if="date" class="col">
      <b-form-datepicker v-model="dateValue" locale="it-IT"></b-form-datepicker>
    </div>
    <div v-if="time" class="col-auto">
      <b-form-timepicker v-model="timeValue" locale="it-IT"></b-form-timepicker>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "DateInput",
    data() {
      return {
        dateValue: "",
        timeValue: "",
        completeValue: this.$props.value,
      }
    },
    props: {
      date: {
        type: Boolean,
        default: false
      },
      time: {
        type: Boolean,
        default: false
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        default: ""
      }
    },
    mounted() {
      let date = moment(this.value);
      this.dateValue = date.format("YYYY-MM-DD");
      this.timeValue = date.format("HH:mm:ss");
    },
    updated() {
      let value = "";
      if (this.date)
        value += this.dateValue;
      if (this.date && this.time)
        value += " ";
      if (this.time)
        value += this.timeValue;

      let newDate = moment(value);
      this.completeValue = newDate.format();
    }
  }
</script>

<style scoped>

</style>
